import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Badge.module.css';

export type BadgeVariant = 'neutral' | 'positive' | 'caution' | 'critical';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  /** Shows the small status dot used throughout the mockups' goal cards. */
  dot?: boolean;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { variant = 'neutral', dot = false, className, children, ...rest },
  ref,
) {
  return (
    <span ref={ref} className={cx(styles.badge, styles[variant], className)} {...rest}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
});
